import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './Dias.css';
import Modal from 'react-modal';
import baseURL from '../url';
import zonaHoraria from '../zonaHoraria';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import SwiperCore from 'swiper/core';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import InputMask from "react-input-mask";
import { apiRaw } from '../../api';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Dias({ idServicio, servicio, servicioNombre, tipoRecurso = 'programa', cupoMax }) {

    const [dias, setDias] = useState([]);
    const [dia, setDia] = useState(null);
    const [numeroSalas, setNumeroSalas] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedHorario, setSelectedHorario] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedDayIndex, setSelectedDayIndex] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [turnos, setTurnos] = useState([]);
    const [inscritosPorDia, setInscritosPorDia] = useState({});
    const [isFocused, setIsFocused] = useState(false);
    const [pago, setPago] = useState('');
    // Estados adicionales para talleres
    const [tallerData, setTallerData] = useState(null);
    const [sesionesTaller, setSesionesTaller] = useState([]);
    const timezone = zonaHoraria;
    const ahora = dayjs().tz(timezone);
    const fechaActual = ahora.format('YYYY-MM-DD');
    const horaActualNum = ahora.hour() + ahora.minute() / 60; // Hora actual en formato numérico
    const minDate = dayjs().add(2, 'day').format('YYYY-MM-DD');

    useEffect(() => {
        if (tipoRecurso === 'taller') {
            cargarDatosTallerPublico();
        } else {
            cargarDias();
            cargarTurnosySalas();
        }
    }, []);

    const cargarDatosTallerPublico = async () => {
        try {
            const response = await apiRaw(`/public/talleres`);
            const data = await response.json();
            
            if (data.error) {
                console.error('Error al cargar taller:', data.error);
                setLoading(false);
                return;
            }

            setTallerData(data.taller);
            setSesionesTaller(data.sesiones || []);
            
            // Construir estructura compatible con el código existente
            // Convertir sesiones a formato de días/horarios
            const sesionesAgrupadas = {};
            data.sesiones?.forEach(sesion => {
                const fecha = sesion.fecha;
                if (!sesionesAgrupadas[fecha]) {
                    sesionesAgrupadas[fecha] = [];
                }
                sesionesAgrupadas[fecha].push({
                    horaInicio: sesion.horaInicio.substring(0, 5),
                    horaFin: sesion.horaFin.substring(0, 5),
                    inscritos: sesion.inscritos,
                    disponibles: sesion.disponibles,
                    lleno: sesion.lleno,
                    idSesion: sesion.idSesion
                });
            });

            // Crear estructura de dias compatible
            const diasFormateados = Object.keys(sesionesAgrupadas).map(fecha => ({
                dia: dayjs(fecha).format('ddd').replace('.', '').toLowerCase(),
                fecha: fecha,
                horarios: sesionesAgrupadas[fecha]
            }));

            setDia({
                dias: diasFormateados,
                idTaller: idServicio
            });
            setLoading(false);
        } catch (error) {
            console.error('Error al cargar datos del taller:', error);
            setLoading(false);
        }
    };

    const cargarDias = () => {
        apiRaw(`/dias`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                if (!data.dias_horarios) {
                    setDias([]);
                    setLoading(false);
                    return;
                }

                // Filtrar solo programas (talleres usan otro flujo)
                const horariosFiltrados = data.dias_horarios.filter(item => 
                    item.tipo_recurso === 'programa' && item.idServicio == idServicio
                );
                setDias(horariosFiltrados);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar días:', error);
                setLoading(false);
            });
    };

    const cargarTurnosySalas = () => {
        apiRaw(`/public/turnos-ocupados/${idServicio}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // Parsear los días
                const turnosConDias = data.turnos
                    ?.map(turno => ({
                        ...turno,
                        dias: JSON.parse(turno.dias), // Convertir la cadena JSON en un objeto
                    })) || [];
                //console.log('Turnos procesados:', turnosConDias);
                setTurnos(turnosConDias);

                //obtenemos las salas del ceseco    
                apiRaw(`/salas/ceseco/${data.idCategoria}`, {
                    method: 'GET',
                }).then(response => response.json())
                    .then(data => {
                        //console.log('Salas cargadas:', data.salas);
                        setNumeroSalas(data.salas.length);

                    }).catch(error => console.error('Error al cargar número de salas:', error));


            })
            .catch(error => console.error('Error al cargar turnos:', error));
    };

    const cargarTurnosTaller = async () => {
        try {
            const response = { json: async () => ({ success: false }) }; // turnos_talleres retirado (tabla eliminada)
            const data = await response.json();

            if (data.success) {
                //console.log('Datos recibidos del servidor:', data.turnos);
                
                const turnosConDias = data.turnos?.map(turno => {
                    // Convertir el string JSON a objeto/array si es necesario
                    let dias = turno.dias;
                    if (typeof dias === 'string') {
                        try {
                            dias = JSON.parse(dias);
                        } catch (e) {
                            console.error('Error al parsear días:', e, 'Valor:', turno.dias);
                            dias = [];
                        }
                    }
                    
                    return {
                        ...turno,
                        dias: Array.isArray(dias) ? dias : []
                    };
                }) || [];

                //console.log('Turnos procesados:', turnosConDias);

                // Contar inscritos por día y horario
                const conteoInscritos = {};
                turnosConDias.forEach(turno => {
                    if (turno.dias && Array.isArray(turno.dias)) {
                        turno.dias.forEach(dia => {
                            if (dia && dia.dia && dia.horaInicio && dia.horaFin) {
                                const key = `${dia.dia}_${dia.horaInicio}_${dia.horaFin}`;
                                conteoInscritos[key] = (conteoInscritos[key] || 0) + 1;
                            }
                        });
                    }
                });
                
                setInscritosPorDia(conteoInscritos);
                setTurnos(turnosConDias);

                try {
                    const responseSalas = await apiRaw(`/salas/ceseco/${data.idCategoria}`);
                    const dataSalas = await responseSalas.json();
                    setNumeroSalas(dataSalas.salas?.length || 1);
                } catch (error) {
                    console.error('Error al cargar salas:', error);
                    setNumeroSalas(1);
                }
            }
        } catch (error) {
            console.error('Error al cargar turnos de taller:', error);
            setNumeroSalas(1); // Valor por defecto
        }
    };

    useEffect(() => {
        if (tipoRecurso === 'taller' && dia?.dias) {
            // Para talleres: solo inicializar si aún no hay día seleccionado
            if (selectedDay) return;
            const monthDays = generateMonthDays();

            for (let i = 0; i < monthDays.length; i++) {
                const day = monthDays[i];
                if (day.date >= minDate) {
                    // Buscar por fecha exacta en lugar de día de la semana
                    const matchingDayInfo = dia.dias?.find(d => d.fecha === day.date);
                    if (matchingDayInfo && matchingDayInfo.horarios?.length > 0) {
                        // Verificar si hay horarios disponibles (no llenos)
                        const hayDisponibles = matchingDayInfo.horarios.some(h => !h.lleno);
                        if (hayDisponibles) {
                            setSelectedDay({ ...matchingDayInfo, date: day.date });
                            setSelectedDayIndex(i);
                            break;
                        }
                    }
                }
            }
        } else if (dias?.length > 0 && !dia) {
            // Para programas: solo inicializar si dia aún no está establecido
            const diasFilt = dias?.find(d => d.idServicio == idServicio);

            if (diasFilt) {
                try {
                    const parsedDias = typeof diasFilt.dias === 'string'
                        ? JSON.parse(diasFilt.dias)
                        : diasFilt.dias;

                    setDia({ ...diasFilt, dias: parsedDias });

                    const monthDays = generateMonthDays();

                    for (let i = 0; i < monthDays.length; i++) {
                        const day = monthDays[i];
                        if (day.date >= minDate) {
                            const matchingDayInfo = parsedDias?.find(d => d.dia === day.day);
                            if (matchingDayInfo && matchingDayInfo.horarios?.length > 0) {
                                const isDayFull = matchingDayInfo.horarios.every(horario =>
                                    turnos?.some(turno =>
                                        turno?.dias?.some(d =>
                                            d.dia === day.date &&
                                            d.horaInicio === horario.horaInicio &&
                                            d.horaFin === horario.horaFin
                                        )
                                    )
                                );
                                if (!isDayFull) {
                                    setSelectedDay({ ...matchingDayInfo, date: day.date });
                                    setSelectedDayIndex(i);
                                    break;
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error('Error al procesar los días:', error);
                }
            } else {
                setDia(null);
            }
        }
    }, [idServicio, dias, tipoRecurso, sesionesTaller]);


    const generateMonthDays = () => {
        const daysInMonth = [];
        const today = dayjs();

        // Vamos a generar los días a partir de hoy hasta 30 días después
        const endDate = today.add(30, 'day'); // 30 días después de hoy

        for (let date = today; date.isBefore(endDate); date = date.add(1, 'day')) {
            daysInMonth.push({
                day: date.format('ddd').replace('.', '').toLowerCase(),
                date: date.format('YYYY-MM-DD'),
            });
        }

        return daysInMonth;
    };


    const handleDayClick = (monthDay, index) => {
        // Para talleres, buscar por fecha exacta; para programas, por día de la semana
        const selectedDayInfo = tipoRecurso === 'taller'
            ? dia?.dias?.find(d => d.fecha === monthDay.date)
            : dia?.dias?.find(d => d.dia === monthDay.day);
        setSelectedDay(selectedDayInfo ? { ...selectedDayInfo, date: monthDay.date } : null);
        setSelectedHorario(null);
        setSelectedDayIndex(index);
    };

    const handleHorarioClick = (horario, date) => {
        setSelectedHorario({ horario, date });
    };



    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const crearTurno = async () => {
        setMensaje('Procesando...');

        try {
            // Validaciones básicas
            if (!nombre || !telefono) {
                setMensaje('');
                Swal.fire('Error', 'Por favor completa todos los campos requeridos', 'error');
                return;
            }

            // Crear el objeto de días y horas (campo dias)
            const diasData = [
                {
                    dia: selectedHorario.date,
                    horaInicio: selectedHorario.horario.horaInicio,
                    horaFin: selectedHorario.horario.horaFin,
                }
            ]

            let response = '';
            if (tipoRecurso === 'taller') {
                // Usar nuevo endpoint para talleres con JSON
                const dataToSend = {
                    idTaller: idServicio,
                    nombre: nombre,
                    telefono: telefono.replace(/-/g, '').replace('+52', ''),
                };

                response = await apiRaw(`/public/talleres/inscripcion`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend),
                });
            } else {
                // Preparar FormData para programas (flujo original)
                const formData = new FormData();
                formData.append('nombre', nombre);
                formData.append('telefono', telefono.replace(/-/g, ''));
                formData.append('idServicio', idServicio);
                formData.append('servicio', servicioNombre || servicio);
                formData.append('estado', 'Pendiente');
                formData.append('dias', JSON.stringify(diasData));  // Agregar los días y horas como JSON
                response = await apiRaw(`/turnos`, {
                    method: 'POST',
                    body: formData,
                });
            }

            const data = await response.json();
            if (data.idTurno || data.mensaje || data.idInscripcion) {
                setMensaje('');

                if (tipoRecurso === 'taller') {
                    const numSesiones = tallerData?.numSesiones || dia?.dias?.length || '';
                    const mensajeExito = data.advertencia 
                        ? `${data.mensaje}\n\n${data.advertencia}`
                        : `¡Inscripción exitosa!\n\nQuedaste inscrito/a en las ${numSesiones} sesiones del taller "${tallerData?.nombre || servicio}".\n\nTe confirmaremos tu inscripción vía WhatsApp al ${data.contacto?.telefono || telefono}.`;
                    
                    Swal.fire(
                        '¡Inscripción al taller completo registrada!',
                        mensajeExito,
                        data.advertencia ? 'warning' : 'success'
                    );
                } else {
                    Swal.fire(
                        'Solicitud de cita enviada',
                        `La Solicitud de cita ha quedado registrada exitosamente, una vez que se valide disponibilidad, le confirmaremos via WhatsApp`,
                        'success'
                    );
                }

                // Limpiar campos y cerrar modal
                setNombre('');
                setTelefono('');
                setMensaje('');
                closeModal();
                
                // Actualizar los datos según el tipo de recurso
                if (tipoRecurso === 'taller') {
                    await cargarDatosTallerPublico();  // Recargar datos del taller
                } else {
                    cargarDias();
                    cargarTurnosySalas();
                }

                /*
                //aqui no se crea ni el pdf ni las notificaciones
                const detallesTurno = {
                    idTurno: data.idTurno,
                    servicio,
                    dia: dayjs(selectedHorario?.date)?.format('dddd'),
                    fecha: dayjs(selectedHorario?.date)?.format('dddd, D [de] MMMM [de] YYYY'),
                    horarioInicio: selectedHorario?.horario?.horaInicio,
                    horarioFin: selectedHorario?.horario?.horaFin,
                    nombre,
                    telefono,
                    categoria,
                    ubicacionTienda,
                };

                //crear pdf y subirlo al servidor
                enviarPdfAlServidor(detallesTurno);

                //crear notificacion
                const formData = new FormData();
                const nombreArchivo = `Cita_${detallesTurno.idTurno}_${detallesTurno.nombre
                    .replace(/\s+/g, "_")
                    .replace(/[^a-zA-Z0-9_]/g, "")}_${detallesTurno.fecha
                        .replace(/\s+/g, "_")
                        .replace(/[^a-zA-Z0-9_]/g, "")}.pdf`;
       
                formData.append('nombreArchivo', nombreArchivo);        
                formData.append('sendTo', detallesTurno.telefono.replace(/-/g, ""));
                formData.append('templateName', 'cliente_confirmacion_cita_v1');
                formData.append('bodyArray', JSON.stringify([
                    detallesTurno.fecha,
                    detallesTurno.nombre,
                    detallesTurno.categoria,
                    detallesTurno.ubicacionTienda
                ]));

                // Realizar petición al servidor
                const response = await apiRaw(`/notificaciones`, {
                method: 'POST',
                    body: formData
                });
               
                */

                setTimeout(() => {
                    setSelectedHorario(null)
                }, 100);

            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                error,
                'error'
            );
        }
    };




    if (loading) {
        return <Swiper
            effect={'coverflow'}
            grabCursor={true}
            slidesPerView={'auto'}
            id="cardsServicio"
        >
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>

            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>

            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
        </Swiper>;
    }

    return (
        <div className='Dias'>
            {dia ? (
                <div>
                    {selectedDay && <div className='horariosSeleccionados'>
                        <h4>{dayjs(selectedDay?.date)?.format('dddd, D [de] MMMM [de] YYYY')}:</h4>
                    </div>
                    }
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        slidesPerView={'auto'}
                        id='cardsServicio'
                    >

                        {generateMonthDays().map((monthDay, index) => {
                            // Para talleres, buscar por fecha exacta; para programas, por día de la semana
                            const matchingDayInfo = tipoRecurso === 'taller'
                                ? dia?.dias?.find(d => d.fecha === monthDay.date)
                                : dia?.dias?.find(d => d.dia === monthDay?.day);

                            // Verificar disponibilidad del día
                            const isDayFull = tipoRecurso === 'taller'
                                ? matchingDayInfo?.horarios?.every(h => h.lleno) || false
                                : matchingDayInfo?.horarios?.every(horario => {
                                    const citasEnSlot = turnos?.filter(turno =>
                                        turno?.dias?.some(d => {
                                            const fechaTurno = dayjs(d.dia).format('YYYY-MM-DD');
                                            return fechaTurno === monthDay.date &&
                                                d.horaInicio === horario.horaInicio &&
                                                d.horaFin === horario.horaFin;
                                        })
                                    ).length;
                                    return citasEnSlot >= numeroSalas;
                                }) || false;

                            const disponibilidadText = matchingDayInfo
                                ? isDayFull
                                    ? <div className="red"></div> // Todos los horarios están ocupados
                                    : <div className="green"></div> // Hay horarios disponibles
                                : <div className="red"></div>; // Día no tiene horarios disponibles

                            return (
                                <SwiperSlide
                                    key={index}
                                    onClick={() => handleDayClick(monthDay, index)}
                                    id={selectedDayIndex === index ? 'selectedDay' : 'cardDay'}
                                >
                                    <h5>{dayjs(monthDay.date)?.format('dddd')}</h5>
                                    <h4>{dayjs(monthDay.date)?.format('D')}</h4>
                                    <h5>{dayjs(monthDay.date)?.format('MMMM')}</h5>
                                    {disponibilidadText}
                                </SwiperSlide>
                            );
                        })}

                    </Swiper>


                    {selectedDay ? (
                        <div className='horariosSeleccionados'>
                            <div className="flexGrapHoras">
                                {selectedDay?.horarios?.map((horario, idx) => {
                                    // Convertir horario de fin a formato numérico
                                    const [horaFin, minutoFin] = horario?.horaFin?.split(':').map(Number);
                                    const horarioFinNum = horaFin + minutoFin / 60;

                                    // Verificar si el horario está ocupado
                                    /*
                                    const isOcupado = turnos?.some(turno =>
                                        turno?.dias?.some(d =>
                                            d.dia === selectedDay.date &&
                                            d.horaInicio === horario.horaInicio &&
                                            d.horaFin === horario.horaFin
                                        )
                                    );
                                    */
                                    const citasEnEsteHorario = turnos?.filter(turno => {
                                        const tieneDia = turno?.dias?.some(d => {
                                            const fechaTurno = dayjs(d.dia).format('YYYY-MM-DD');
                                            const fechaSeleccionada = dayjs(selectedDay.date).format('YYYY-MM-DD');
                                            const coincide = fechaTurno === fechaSeleccionada && 
                                                           d.horaInicio === horario.horaInicio && 
                                                           d.horaFin === horario.horaFin;
                                            
                                            if (coincide) {
                                                /*
                                                console.log('Turno encontrado:', {
                                                    fechaTurno,
                                                    fechaSeleccionada,
                                                    horaInicio: d.horaInicio,
                                                    horaFin: d.horaFin,
                                                    turno
                                                });
                                                */
                                            }
                                            
                                            return coincide;
                                        });
                                        return tieneDia;
                                    }).length;

                                    //console.log('Citas encontradas para', selectedDay.date, horario.horaInicio, '-', horario.horaFin, ':', citasEnEsteHorario);
                                    //console.log('Turnos disponibles:', turnos);

                                    // Para talleres: usar datos directos de sesión
                                    // Para programas: verificar contra salas
                                    const isOcupado = tipoRecurso === 'taller' 
                                        ? (horario.lleno || false) // Datos vienen del endpoint
                                        : citasEnEsteHorario >= numeroSalas;
                                    
                                    const inscritosActuales = tipoRecurso === 'taller'
                                        ? horario.inscritos || 0
                                        : citasEnEsteHorario;
                                    
                                    const cupoMaximo = tipoRecurso === 'taller'
                                        ? (tallerData?.cupoMax || cupoMax)
                                        : numeroSalas;

                                    // Verificar si el horario ya pasó
                                    const isHorarioPasado = dayjs(selectedDay.date).isBefore(minDate, 'day');

                                    // Determinar el estilo del botón
                                    const buttonStyles = {
                                        cursor: isOcupado || isHorarioPasado ? 'not-allowed' : 'pointer',
                                        backgroundColor: isOcupado
                                            ? (tipoRecurso === 'taller' && isOcupado)
                                                ? '#ff000026' // Rojo claro para talleres llenos
                                                : '#06b5b826' // Azul claro para programas ocupados
                                            : isHorarioPasado
                                                ? '#ff000018' // Rojo claro para horarios pasados
                                                : '',
                                        color: isOcupado
                                            ? (tipoRecurso === 'taller' && isOcupado)
                                                ? '#ff0000' // Rojo para talleres llenos
                                                : '#06b5b8' // Azul para programas ocupados
                                            : isHorarioPasado
                                                ? '#ff0000' // Rojo para horarios pasados
                                                : '',
                                    };

                                    return (
                                        <button
                                            key={idx}
                                            onClick={() => !isOcupado && !isHorarioPasado && handleHorarioClick(horario, selectedDay.date)}
                                            style={buttonStyles}
                                            disabled={isOcupado || isHorarioPasado} // Desactivar si el horario está ocupado o ya pasó
                                        >
                                            {horario.horaInicio} - {horario.horaFin}
                                            {tipoRecurso === 'taller' && cupoMaximo > 0 && (
                                                <span style={{fontSize: '0.8em', display: 'block'}}>
                                                    {inscritosActuales}/{cupoMaximo} lugares
                                                </span>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <h4 className="textCenter">Selecciona un día para ver sus horarios.</h4>
                    )}

                    {selectedHorario && (
                        <button className="btnFlotant" onClick={openModal}>
                            {tipoRecurso === 'taller' 
                                ? `Inscribirse al taller completo (${tallerData?.numSesiones || dia?.dias?.length || ''} sesiones)` 
                                : `Agendar cita de ${selectedHorario?.horario?.horaInicio} - ${selectedHorario?.horario?.horaFin}`
                            }
                        </button>
                    )}
                    <Modal
                        isOpen={modalIsOpen}
                        className="modal-cart"
                        overlayClassName="overlay-cart"
                        onRequestClose={closeModal}
                    >
                        <div className='deFLex'></div>
                        <div className='deFLex'>
                            <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                            <button className='deleteToCart'>{tipoRecurso === 'taller' ? 'Inscribirse al taller' : 'Reservar cita'}</button>
                        </div>
                        <div className="modal-content-cart">


                            <div className="modal-send-form">
                                {selectedHorario && (
                                    <div className='deFLexRadio'>
                                        <p><strong>{tipoRecurso === 'taller' ? 'Taller:' : 'Tipo de cita:'}</strong> {servicio}</p>
                                        {tipoRecurso === 'taller' ? (
                                            <>
                                                <div style={{
                                                    backgroundColor: '#fff3cd', 
                                                    border: '1px solid #ffc107', 
                                                    borderRadius: '8px', 
                                                    padding: '12px', 
                                                    marginTop: '10px',
                                                    marginBottom: '10px'
                                                }}>
                                                    <p style={{margin: '0 0 8px 0', color: '#856404', fontWeight: 'bold'}}>
                                                        📋 Inscripción al taller completo
                                                    </p>
                                                    <p style={{margin: '0 0 8px 0', fontSize: '0.9em', color: '#856404'}}>
                                                        Te inscribirás a las {tallerData?.numSesiones || dia?.dias?.length || 'todas las'} sesiones del taller:
                                                    </p>
                                                    {dia?.dias && dia.dias.length > 0 && (
                                                        <ul style={{margin: '0', paddingLeft: '20px', fontSize: '0.85em', color: '#856404'}}>
                                                            {dia.dias.slice(0, 10).map((sesion, idx) => (
                                                                <li key={idx}>
                                                                    {dayjs(sesion.fecha).format('ddd D/MMM')} - {sesion.horarios?.[0]?.horaInicio || ''} a {sesion.horarios?.[0]?.horaFin || ''}
                                                                </li>
                                                            ))}
                                                            {dia.dias.length > 10 && <li>... y {dia.dias.length - 10} sesiones más</li>}
                                                        </ul>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {/* <p>Día: {dayjs(selectedHorario?.date)?.format('dddd')}</p> */}
                                                <p>Fecha: {dayjs(selectedHorario?.date)?.format('dddd, D [de] MMMM [de] YYYY')}</p>
                                                <p>Horario: {selectedHorario?.horario?.horaInicio} - {selectedHorario?.horario?.horaFin}</p>
                                            </>
                                        )}
                                    </div>
                                )}
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    placeholder={tipoRecurso === 'taller' ? 'Nombre y Apellido (*)' : 'Paciente: Nombre y Apellido (*)'}
                                />
                                <InputMask
                                    mask="+52-99-99-99-99-99"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <input
                                            {...inputProps}
                                            type="tel"
                                            id="telefono"
                                            name="telefono"
                                            placeholder="+52-00-00-00-00-00 (*)"
                                        />
                                    )}
                                </InputMask>
                                <hr />
                                <p><strong>Condiciones generales:</strong></p>
                                <ul>
                                    {tipoRecurso === 'taller' ? (
                                        <>
                                            <li>Te inscribes al taller completo, debiendo asistir a todas las sesiones programadas.</li>
                                            <li>Si eres menor de edad, tu tutor debe acompañarte y presentar identificación oficial.</li>
                                            <li>Para cancelar tu inscripción, contáctanos con al menos 48 horas de anticipación.</li>
                                        </>
                                    ) : (
                                        <>
                                            <li>Si el paciente es menor de edad, el tutor que lo acompañe a la cita debe presentar una identificación oficial.</li>
                                            <li>En caso de no poder asistir, por favor cancelar con 24 horas de anticipación.</li>
                                        </>
                                    )}
                                </ul>
                                <hr />
                                {mensaje ? (
                                    <button type='button' className='btn' disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <button type='button' onClick={crearTurno} className='btn'>
                                        Finalizar
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal>
                </div >
            ) : (
                <h4 className="textCenter">No se encontraron días para este servicio.</h4>
            )}
        </div >
    );
}
